import { createContext, useContext } from 'react';
import type { FileInfo } from '../../services/lambdaService';
import type { SchemaColumn, SearchCriteria } from '../../services/sheetsService';

/** Demo state exposed to SheetsPage via context */
export interface SheetsDemoState {
  /** Mock files for the sidebar */
  files?: FileInfo[];
  /** Currently "selected" file */
  selectedFile?: FileInfo | null;
  /** Mock schema columns */
  schema?: SchemaColumn[];
  /** Mock total row count */
  totalRows?: number;
  /** Mock data rows */
  rows?: Record<string, unknown>[];
  /** Mock search results */
  searchResults?: Record<string, unknown>[];
  /** Mock matched count */
  totalMatched?: number;
  /** Mock active filter */
  activeFilter?: SearchCriteria | null;
  /** Mock query time */
  lastQueryTime?: number;
  /** Whether demo is active (any phase) */
  active: boolean;
}

export const SheetsDemoCtx = createContext<SheetsDemoState | null>(null);

/** Returns demo state if on demo subdomain, null otherwise */
export function useSheetsDemoContext(): SheetsDemoState | null {
  return useContext(SheetsDemoCtx);
}
